import type { FunctionComponent } from "react"

import IconInformationOutline from "@jobteaser/ui-kit/assets/icons/jds_informationOutline.svg"
import { Icon, ICON_SIZES } from "@jobteaser/ui-kit/components/Icon/Icon"
import { RichText } from "@jobteaser/ui-kit/components/RichText/RichText"
import { DATA_SPACER } from "@jobteaser/ui-kit/constants/enums"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"

import styles from "./StatusUserNotAvailable.module.css"

export const StatusUserNotAvailable: FunctionComponent = () => {
  const { t } = useTranslation(["event_details"])

  const locale = useLocale()
  const myEventsPath = `<a href='/${locale}/dashboard/my_events'>
  ${t("event_details.registration.not.available.link")}
</a>`

  return (
    <div
      className={styles.main}
      data-spacer={DATA_SPACER.TOP_200}
      data-testid="event-details-registration-details-user-status-not-available"
    >
      <Icon
        className={styles.icon}
        xlinkHref={`#${IconInformationOutline.id}`}
        size={ICON_SIZES.SMALL}
        dataSpacer={DATA_SPACER.TOP_50}
      />
      <RichText className={styles.text} data-testid="event-details-registration-details-user-status-not-available-text">
        {t("event_details.registration.not.available", {
          my_events_link: myEventsPath,
        })}
      </RichText>
    </div>
  )
}
